import { FC } from 'react';
import styled from 'styled-components';

import { spacing, colors } from 'ui/theme';

import { useTreeViewContext } from '../context/TreeViewContext';
import { RootProps } from '../types';

type TableStyleProps = {
  tableColor?: string;
};

const Table = styled.div<TableStyleProps>`
  > .json-row:nth-child(odd) {
    background-color: ${({ tableColor = colors.backgroundSecondary }) => tableColor};
    border-radius: ${spacing.half};
  }

  > .json-row:nth-child(even) {
    background-color: ${colors.white};
  }
`;

export const Root: FC<React.PropsWithChildren<RootProps>> = ({ children }) => {
  const { tableColor } = useTreeViewContext();

  return (
    <Table className="json-root" data-test="json-root-table" tableColor={tableColor}>
      {children}
    </Table>
  );
};
